import { render } from "./DocumentExecutionNotesList.vue?vue&type=template&id=1d2c82e5&scoped=true&ts=true"
import script from "./DocumentExecutionNotesList.vue?vue&type=script&lang=ts"
export * from "./DocumentExecutionNotesList.vue?vue&type=script&lang=ts"

import "./DocumentExecutionNotesList.vue?vue&type=style&index=0&id=1d2c82e5&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2c82e5"]])

export default __exports__